module.exports = __webpack_public_path__ + "static/draw-0f5a5440ee60311f42e9017e8721a98f.png";